import { keyframes } from '@emotion/react';
import { Box } from '@hover/blueprint';
import type { ReactElement } from 'react';
import React, { useEffect, useState } from 'react';

const ANIMATION_TIME = 750;

const fadeAnimation = keyframes`
 0% { opacity: 100%; transform: scale(1); }
 100% { opacity: 0%; transform: scale(1.2); }
`;

interface FadingContainerProps {
  children: ReactElement;
  visible: boolean;
}

const FadingContainer = ({ children, visible }: FadingContainerProps) => {
  const [mounted, setMounted] = useState(true);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (!visible) {
      setAnimating(true);
      setTimeout(() => {
        setMounted(visible);
        setAnimating(false);
      }, ANIMATION_TIME);
    }
  }, [visible]);

  if (!mounted && !animating) {
    return null;
  }

  return (
    <Box
      bottom={0}
      height="100vh"
      id="fade-container"
      overflow="hidden"
      position="absolute"
      sx={{
        animation: `${fadeAnimation} ${ANIMATION_TIME}ms`,
        animationPlayState: animating ? 'running' : 'paused',
      }}
      top={0}
      width="100vw"
    >
      {children}
    </Box>
  );
};

export { FadingContainer };
